import React from "react";
import DOMPurify from 'dompurify';
import { useTranslation } from "react-i18next";
import { useStore } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { choosePlan } from 'state/actions';
import { useSelector } from 'react-redux';
import { getLocalePrefix } from '../../../helpers/util';

const PriceCard = ({ plan, subscriptionid }) => {
    const auth = useSelector(store => store.auth);
    const currency = useSelector(store => store.currency);
    const { t } = useTranslation();
    const { dispatch } = useStore();
    const navigate = useNavigate();

    const handlerChoosePlan = () => {
        dispatch(choosePlan(plan))
        return navigate(getLocalePrefix() + '/checkout/' + plan.id);
    }

    const BestValue = () => {
        return plan.best ?
            <p className="plans-bestvalue text-white text-bold pt-1 pb-72">{t("labels.best_value")}</p>
            : null
    }

    const PriceValue = () => {
        const price_value = (plan.price && plan.price > 0) ? (currency?.symbol + (parseFloat(plan.price).toFixed(2)) + " / month") : 'Free';
        const save_value = Math.round((plan.price > 0 ? (plan.base_price - plan.price) / plan.base_price : 0) * 100);

        return (
            <h3 data-test-id={"plan-" + plan.name + "-price"} className="mb-5">
                {price_value}<br />
                <span className="text-big text-green">{save_value > 0 ? `Save ${save_value}%` : ''}</span>
            </h3>)
    }

    const ChoosePlan = () => {
        if (auth && !(plan.price > 0)) return null

        return (
            <button data-test-id={"plan-" + plan.name + "-choose"} onClick={() => { handlerChoosePlan() }} className="btn h-42 px-12">
                {t("buttons.btn_choose_plan")}
            </button>
        )
    }

    return (
        <>
            <BestValue />
            <div className="mb-3">
                <h2 data-test-id={"plan-" + plan.name} className="text-color-changeable">{plan.title}</h2>
                <PriceValue />
                <div data-test-id={"plan-" + plan.name + "-description"} className="plans-description text-small text-bold" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(plan.detail) }}></div>
            </div>
            <ChoosePlan />
        </>
    );
};

export default PriceCard;
